
import { defineComponent } from 'vue'
import BaseInput from '@/components/BaseInput.vue'
import BaseInputCurrency from '@/components/BaseInputCurrency.vue'
import BaseInputPercentage from '@/components/BaseInputPercentage.vue'
import BaseLabel from '@/components/BaseLabel.vue'
import FormRow from '@/components/FormRow.vue'
import Heading from '@/components/Heading.vue'
import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import useCalculator from '@/composables/useCalculator'

export default defineComponent({
  components: {
    BaseInputCurrency,
    BaseInputPercentage,
    BaseLabel,
    FormRow,
    Heading,
    BaseInput,
    Loading,
    Modal,
    PrimaryButton
  },

  setup () {
    const { isModalOpen, setIsModalOpen, loading, loan, saveLoan } = useCalculator()

    return {
      isModalOpen,
      setIsModalOpen,
      saveLoan,
      loading,
      loan
    }
  }
})
